import * as angular from 'angular';
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import DefectClassificationServiceName, {DefectClassificationService} from "../../services/defects/defectClassification.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import DefectTypeDetailsService from "../../models/defectType";
import {apsEnums} from "../../shared/dto/aps.enums";
import {Enums} from "../../shared/config/constant.module";
import * as _ from "lodash";
import template from './editDefectType.tpl.html';

let requires = [NotifyServiceName, LoaderServiceName, DefectTypeServiceName, DefectClassificationServiceName,
  UIUtilityServiceName, DefectTypeDetailsService];

export default angular.module('aps.controller.editDefectType', requires)
  .controller('EditDefectTypeCtrl', editDefectTypeCtrl)
  .name;

export interface EditDefectTypeData {
  defectTypeId: string;
}

export function openEditDefectType(data: EditDefectTypeData,
                                   $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditDefectTypeCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

function editDefectTypeCtrl(
  $modalInstance: mm.foundation.modalInstance,
  $timeout: angular.ITimeoutService,
  notifyService: NotifyService,
  loaderService: LoaderService,
  data: EditDefectTypeData,
  defectTypeService: DefectTypeService,
  defectClassificationService: DefectClassificationService,
  defectTypeDetailsViewModelService,
  uiUtilityService: UIUtilityService
) {
  var vm = this;
  var defectTypeImageFileIdentifier = 'defectTypeImage';
  var defectTypeImageSrcIdentifier = 'defectTypeImageSrc';
  var fileReader = new FileReader();

  vm.displayWareClasses = false;

  vm.defectTypeId = data.defectTypeId;
  vm.severities = _.toArray(Enums.SEVERITY);
  vm.unqualificationScopes = uiUtilityService.getListOptionsFromEnum(apsEnums.UnqualificationScope);
  vm.wareClassesArray = [];

  var loadWareClasses = function() {

    if (((vm.defectTypeDetails || '') !== '') && ((vm.wareClasses || '') !== '')) {

      var wareClassesSeverityFound = false;

      _.each(vm.wareClasses, function (wCItem: any) {

        var id = '';
        var severity = '';

        var wareClass = _.find(vm.defectTypeDetails.wareClasses, function (item: any) {
          return item.wareClassId === wCItem.id;
      });

        if ((wareClass || '') !== '') {
          wareClassesSeverityFound = ((wareClass.severity || '') !== '') ? true : wareClassesSeverityFound;
          id = wareClass.id;
          severity = wareClass.severity;
        }

        vm.wareClassesArray.push({
          id: id,
          wareClass: wCItem,
          severity: severity
        });

      });

      vm.displayWareClasses = wareClassesSeverityFound;
    }
  };

  var fillWareClasses = function() {

    _.each(vm.wareClassesArray, function(defectWareClass: any){

      var itemFound = false;
      var severity = vm.displayWareClasses ? defectWareClass.severity : '';

      var wc = _.find(vm.defectTypeDetails.wareClasses, function (item: any) {
        return item.wareClassId === defectWareClass.wareClass.id;
      });

      if ((wc || '') !== '') {
        itemFound = true;
        wc.severity = severity;
      }

      if (itemFound === false) {
        vm.defectTypeDetails.wareClasses.push({
          wareClassId: defectWareClass.wareClass.id,
          defectTypeId: vm.defectTypeDetails.id,
          severity: severity
        });
      }
    });
  };

  var postDefectType = function() {
    var promise = defectTypeService.submitDefectType(vm.defectTypeDetails)
      .then(function () {
        var data = {
          action: 'return',
          defectTypeDetails: vm.defectTypeDetails
        };
        $modalInstance.close(data);
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  defectClassificationService.getDefectClassifications().then(function(defectClassifications){
    vm.defectClassifications = defectClassifications;
  });

  defectTypeService.getDefectTypeWareClasses().then(function(wareClasses){
    vm.wareClasses = wareClasses;
    loadWareClasses();
  });

  var promise = defectTypeService.getDefectTypeDetails(vm.defectTypeId)
    .then(function(defectTypeDetails){
      defectTypeDetailsViewModelService.apply(defectTypeDetails);
      vm.defectTypeDetails = defectTypeDetails;
      loadWareClasses();
    }, notifyService.handleApiErrors);
  loaderService.loadingPromise(promise);

  fileReader.onload = function (event) {
    if (((<any>event.target).result || '') !== '') {
      var uri = (<any>event.target).result;
      vm.defectTypeDetails.defectImage = uri;
      var defectTypeImageSrc = angular.element('#' + defectTypeImageSrcIdentifier);
      if ((defectTypeImageSrc || '') !== '') {
        if ((defectTypeImageSrc[0] || '') !== '') {
          (<any>defectTypeImageSrc[0]).src = uri;
        }
      }
    }
  };

  vm.fileNameChanged = function(value) {
    var defectTypeImageFile = angular.element('#' + defectTypeImageFileIdentifier);
    if ((defectTypeImageFile || '') !== '') {
      if ((defectTypeImageFile[0] || '') !== '') {
        if (((<any>defectTypeImageFile[0]).files[0] || '') !== '') {
          fileReader.readAsDataURL((<any>defectTypeImageFile[0]).files[0]);
        }
      }
    }
  };

  vm.submitDefectType = function() {
    if (vm.form.$invalid) {
      return;
    }

    fillWareClasses();
    postDefectType();
  };

  var scrollToHeader = function() {
    var top = angular.element('body').scrollTop();
    var offset = angular.element('.modal-header').offset();
    if (offset.top < (top - 50)) {
      angular.element('body').animate({scrollTop: offset.top - 50}, 50);
    }
  };

  vm.editDefectCauseModal = function(defectCause){
    scrollToHeader();
    $timeout(() => {
      var data = {
        action: 'editCause',
        defectCause: defectCause,
        defectTypeId: vm.defectTypeId
      };
      $modalInstance.close(data);
    }, 250);
  };

  vm.addDefectCauseModal = function(){
    scrollToHeader();
    $timeout(() => {
      var data = {
        action: 'addCause',
        defectTypeId: vm.defectTypeId
      };
      $modalInstance.close(data);
    }, 250);
  };

  vm.cancel = function() {
    $modalInstance.close({
      action: 'close',
      defectTypeId: vm.defectTypeId
    });
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/defectTypeAdmin/editDefectType.controller.ts